import { Typography } from '@mui/material';
import React from 'react';
import { getExperianComponent, termsAndConditions } from './helpers';
import { ExperianFormProps } from './types';

export default function ExperianForm(
  props: ExperianFormProps,
) {
  const {
    values, handleChange, queriesArray, setFieldValue,
    handleCurrentData, handleStep, handleEnableLoading,
    handleUnemployedFallback,
    patchManualVerificationFallback,
  } = props;

  return (
    <div>
      <Typography variant="h6" align="center" gutterBottom>
        ¡Necesitamos validar tus ingresos a través de tus cotizaciones!
      </Typography>
      <br />
      <div style={{ textAlign: 'center' }}>
        {getExperianComponent({
          values,
          handleChange,
          queriesArray,
          setFieldValue,
          handleCurrentData,
          handleStep,
          handleEnableLoading,
          handleUnemployedFallback,
          patchManualVerificationFallback,
        })}
      </div>
      <br />
      <Typography
        fontStyle="italic"
        variant="body2"
        color="GrayText"
        style={{ borderRadius: '10px', padding: '10px', background: 'whitesmoke' }}
      >
        {termsAndConditions}

      </Typography>
    </div>
  );
}
